import React from "react";
import { useHistory } from "react-router-dom";
import { WSPageToolbar } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { RequirementContextType } from "../../../../Requirements/types";
import { useRequirementsConfig } from "../../../../Requirements/useRequirementsConfig";
import { RequirementDetailsContent } from "../../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";

type RequirementsDetailsProps = {
  requirement: IRequirementResponse;
};

export const PayeeRequirementDetails: React.FC<RequirementsDetailsProps> = ({
  requirement
}) => {
  const history = useHistory();

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payee
  });

  const title =
    requirementConfig.getRequirementName(requirement) || "Requirement";

  const headerActions =
    requirementConfig.getOnboardingToolbarActions(requirement)?.(
      history.goBack
    ) || [];

  return (
    <>
      <WSPageToolbar title={title} actions={headerActions} />

      <RequirementDetailsContent
        {...requirementConfig}
        contextType={RequirementContextType.Payee}
        requirement={requirement}
        showTitle={false}
      />
    </>
  );
};
